<template>
  <div id="config-add-ons-details-wrapper">
    <image-input @scs-input="photoInput" :initial="subject.photo" />
    <div class="input-group">
      <Input
        class="scs-input"
        heading="Add-On Name"
        placeholder="Add-On Name"
        :initialValue="subject.name"
        @scs-input="nameInput"
      />
      <Input
        class="scs-input"
        heading="Add-On Description"
        placeholder="Add-On Description"
        :initialValue="subject.description"
        @scs-input="descriptionInput"
      />
    </div>
  </div>
</template>
<script>
import Input from "../../../../../../Components/Elements/Input.vue";
import ImageInput from "../../../../../../Components/Elements/PhotoInput.vue";
export default {
  methods: {
    photoInput(val) {
      this.$emit("photo-input", val);
    },
    nameInput(val) {
      this.$emit("name-input", val);
    },
    descriptionInput(val) {
      this.$emit("description-input", val);
    },
  },
  components: { ImageInput, Input },
  props: ["subject"],
  emits: ["name-input", "description-input", "photo-input"],
};
</script>
<style scoped>
@media screen {
  #config-add-ons-details-wrapper {
    /* padding: 60px; */
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .input-group {
    /* width: 100%; */
    max-width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .scs-input {
    /* width: 100%; */
  }
  @media (min-width: 800px) {
    #config-add-ons-details-wrapper {
      width: unset;
      padding: 60px;
      flex-direction: row;
    }
    .input-group {
      width: 70%;
    }
    .scs-input {
      width: 100%;
    }
  }
}
</style>
